import { OneWayInServiceDto, PublicationState } from 'src/api/v2';

export enum ServiceStatuses {
  Active = 'active',
  Inactive = 'inactive',
  Draft = 'draft',
}

export function getServiceStatus(service: OneWayInServiceDto): ServiceStatuses {
  if (
    service.state === PublicationState.Active &&
    new Date(service.validFrom!) <= new Date() &&
    new Date(service.validTo!) >= new Date()
  ) {
    return ServiceStatuses.Active;
  }
  if (service.state === PublicationState.Draft) {
    return ServiceStatuses.Draft;
  }
  return ServiceStatuses.Inactive;
}
